// @flow
import React, { Component, type Node } from 'react';

import DepartureCitiesContext, { type departureCitiesContextType } from './DepartureCitiesContext';

type Props = {
  children: Node,
};

export default class DepartureCitiesProvider extends Component<Props, departureCitiesContextType> {
  state = {
    departureCities: [],
    setDepartureCities: (
      departureCities: $PropertyType<departureCitiesContextType, 'departureCities'>,
    ) => {
      this.setState({
        departureCities,
      });
    },
  };

  render() {
    return (
      <DepartureCitiesContext.Provider value={this.state}>
        {this.props.children}
      </DepartureCitiesContext.Provider>
    );
  }
}
